import { useCallback } from "react";

import { skipToken } from "@tanstack/react-query";
import { useChatId } from "@v2/features/chat/hooks/useChatId";
import { chatRouter, chatUtils } from "@v2/trpc/routes/chat";
import { ReploError } from "schemas/errors";

class ChatTurnError extends ReploError {}

export function useChatTurn() {
  const chatId = useChatId();

  const { data: chatTurn } = chatRouter.getLatestChatTurn.useQuery(
    chatId
      ? {
          chatId,
        }
      : skipToken,
  );

  const chatTurnId = chatTurn?.id;

  const { mutateAsync: addChatTurn } = chatRouter.addChatTurn.useMutation({
    onSuccess: () => {
      void chatUtils.getLatestChatTurn.invalidate();
    },
  });

  const getChatTurnId = useCallback(() => {
    if (!chatTurnId) {
      throw new ChatTurnError({
        message: "Chat turn ID not found from the database",
      });
    }

    return chatTurnId;
  }, [chatTurnId]);

  return { getChatTurnId, addChatTurn };
}
